module.exports = __webpack_public_path__ + "static/img/4-04.49090cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/4-04.png
// module id = 237
// module chunks = 0